<template>
  <span v-cloak>
    <div class="d-flex align-center">
      <div v-if="d_day > 0">
        <p
          class="mb-0 mr-5 mt-0 hover hidden-xs-only"
          @click="movePayment()"
          style="width: 200px; text-align:end;"
        >
          서비스 사용중 (D-day {{ d_day }})
        </p>
        <p
          class="mb-0 mr-5 mt-0 hover hidden-xl-only hidden-lg-only hidden-md-only hidden-sm-only"
          style="width: 90px; text-align:end;"
          @click="movePayment()"
        >
          <font class="text-xs-caption"> D-day {{ d_day }}</font>
        </p>
      </div>

      <div v-else>
        <p
          class="mb-0 mr-5 mt-0 hover"
          @click="movePayment()"
          style="width: 190px;"
        >
          사용 기간 만료되었습니다.
        </p>
      </div>

      <v-btn
        depressed
        small
        color="white"
        class="black--text font-weight-black mr-3"
        aling="left"
        @click="useGuldeImageShow()"
        >사용 가이드</v-btn
      >

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            depressed
            small
            color="amber lighten-1"
            class="black--text font-weight-black mr-4"
            aling="left"
            @click="chromeDownLoad()"
            v-bind="attrs"
            v-on="on"
            >크롬 다운로드</v-btn
          >
        </template>
        <span
          >포인트 판매 서비스는<br />
          안전한 크롬 브라우저에 최적화되어 있습니다.<br />
          크롬 브라우저로 사용하시길 권장합니다.</span
        >
      </v-tooltip>

      <template style="margin-top:10px;">
        <div class="text-center">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon color="white">mdi-apps</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                class="hover"
                @click="cafe24SiteShow('https://store.cafe24.com/apps/10777')"
                style="text-decoration: none !important;"
              >
                <v-list-item-avatar tile size="80" color="grey"
                  ><img
                    src="https://cert-product.shoplus.store/authservice/etc/service_images/survey_icon.jpg"
                /></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-bold body-1 black--text mb-0 d-block"
                  >
                    <p
                      class="mb-1 float-left align-center justify-center"
                      style="line-height: 1.8;"
                    >
                      맞춤 질문 추천 서비스
                    </p>
                    <p class="mb-1 float-right">
                      <v-icon>mdi-chevron-right</v-icon>
                    </p>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    고객 취향에 맞춘 개인화 상품 추천서비스.<br />
                    고객이 선택한 답변에 따라 상품을 추천하므로<br />
                    구매율과 만족도를 높여줍니다.<br />
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                class="hover"
                @click="cafe24SiteShow('https://store.cafe24.com/apps/6711')"
                style="text-decoration: none !important;"
              >
                <v-list-item-avatar tile size="80" color="grey"
                  ><img
                    src="https://cert-product.shoplus.store/authservice/etc/service_images/membership.jpg"
                /></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-bold body-1 black--text mb-0 d-block"
                  >
                    <p
                      class="mb-1 float-left align-center justify-center"
                      style="line-height: 1.8;"
                    >
                      유료 멤버십 서비스
                    </p>
                    <p class="mb-1 float-right">
                      <v-icon>mdi-chevron-right</v-icon>
                    </p>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    >쇼핑몰 회원들에게 제공되는 차별화된 서비스.<br />
                    쇼핑몰 구독시대에 필요한 특별한 서비스로<br />
                    고객 이탈을 막고 충성고객을
                    확보하세요.</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                class="hover"
                @click="cafe24SiteShow('https://store.cafe24.com/apps/4238')"
                style="text-decoration: none !important;"
              >
                <v-list-item-avatar tile size="80" color="grey"
                  ><img
                    src="https://cert-product.shoplus.store/authservice/etc/service_images/auth-code-service-icon.jpg"
                /></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-bold body-1 black--text mb-0 d-block"
                  >
                    <p
                      class="mb-1 float-left align-center justify-center"
                      style="line-height: 1.8;"
                    >
                      정품 인증 서비스
                    </p>
                    <p class="mb-1 float-right">
                      <v-icon>mdi-chevron-right</v-icon>
                    </p>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    >회원가입 및 브랜드 가치를 높여주는 서비스.<br />
                    정품 인증 회원에게 다양한 프로모션을 제공하고<br />
                    충성 고객으로 만들어보세요!</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </div>
  </span>
</template>
<style scoped>
[v-clock] {
  display: none;
}
.eAppVersion {
  color: white;
  text-decoration: none;
}
.eAppVersion:hover {
  text-decoration: underline;
}
.v-menu__content--fixed {
  margin-top: 20px;
  max-width: 450px;
}
.v-tooltip__content--fixed {
  margin-top: 20px;
}
</style>
<script>
import M from "@/libs/mapping.js";

let dayjs = require("dayjs");

export default {
  data: () => ({
    M,
    menu: false,
    expires_at: null,
    d_day: null,
  }),
  methods: {
    movePayment: function() {
      if (this.$route.path == `/mileage/${this.$store.state.mallId}/payment`) {
        return false;
      }
      this.$router.push({
        path: `/mileage/${this.$store.state.mallId}/payment`,
      });
    },
    chromeDownLoad: function() {
      window.open("https://www.google.com/intl/ko/chrome/", "_blank");
    },
    cafe24SiteShow: function(url) {
      window.open(url, "_blank");
    },
    expiresDaysCount: function() {
      const today = dayjs();
      const expires_at = dayjs(this.expires_at);
      let diff_day = expires_at.diff(today, "day", true);
      if (isNaN(diff_day) === false && diff_day > 0) {
        this.d_day = Math.floor(diff_day);
        this.$store.state.mode = "enabled";
      } else {
        this.d_day = null;
        this.$store.state.mode = "disabled";
      }
    },
    getMallInfo: async function() {
      try {
        let res = await M.api(M.entry("/get/mileage/usage"));
        localStorage.setItem("mall_name", res.mall_name);
        localStorage.setItem("expires_at", res.expires_at);
        this.expires_at = res.expires_at;
      } catch (e) {
        //
        localStorage.setItem("mall_name", "");
        localStorage.setItem("expires_at", "");
      }
    },
    useGuldeImageShow: function() {
      window.open(`/images/point_sales_service.pdf`, "_blank");
    },
  },
  mounted: async function() {
    await this.getMallInfo();
    this.expiresDaysCount();
  },
};
</script>
